"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mysunrunDateFormat = exports.isSameYear = exports.isSameDay = void 0;

var _luxon = require("luxon");

var mysunrunDateFormat = function mysunrunDateFormat(dateISO, zone) {
  var year = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!dateISO || !_luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).isValid) {
    return null;
  }

  if (year) {
    return _luxon.DateTime.fromISO(dateISO, {
      zone: zone
    }).toFormat('MMM d, yyyy');
  }

  return _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).toFormat('MMM d');
};

exports.mysunrunDateFormat = mysunrunDateFormat;

var isSameDay = function isSameDay(isoDate1, isoDate2, zone) {
  return _luxon.DateTime.fromISO(isoDate1, {
    zone: zone
  }).hasSame(_luxon.DateTime.fromISO(isoDate2, {
    zone: zone
  }), 'day');
};

exports.isSameDay = isSameDay;

var isSameYear = function isSameYear(isoDate1, isoDate2, zone) {
  return _luxon.DateTime.fromISO(isoDate1, {
    zone: zone
  }).hasSame(_luxon.DateTime.fromISO(isoDate2, {
    zone: zone
  }), 'year');
};

exports.isSameYear = isSameYear;